import { render } from "./user-lookup.vue?vue&type=template&id=0cbe1658"
import script from "./user-lookup.vue?vue&type=script&lang=js"
export * from "./user-lookup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__